module.exports = __webpack_public_path__ + "9bae38eab999505701a73a3639c3c41c.svg";